module.exports = __webpack_public_path__ + "img/ripple1.cd99081e.png";